import {
  NOTICE_THEME_VARS,
  THEMED_ACCENT,
  THEMED_CONTROL_OFF,
  THEMED_TTS_BACKGROUND,
  TTS_TEXT_ATTRIBUTE,
} from "../shared/appearance";

const STYLE_ID = "redacto-consent-checkbox-styles";

const STYLE_CONTENT = `
    /* Redacto Consent SDK Checkbox Styles */
    .redacto-checkbox-large {
      appearance: none !important;
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
      height: 20px !important;
      width: 20px !important;
      border: 2px solid ${THEMED_CONTROL_OFF} !important;
      border-radius: 5px !important;
      background-color: transparent !important;
      cursor: pointer !important;
      position: relative !important;
      box-sizing: border-box !important;
      flex-shrink: 0 !important;
      margin: 0 !important;
      padding: 4px !important;
    }

    .redacto-checkbox-medium {
      appearance: none !important;
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
      height: 17px !important;
      width: 17px !important;
      border: 2px solid ${THEMED_CONTROL_OFF} !important;
      border-radius: 5px !important;
      background-color: transparent !important;
      cursor: pointer !important;
      position: relative !important;
      box-sizing: border-box !important;
      flex-shrink: 0 !important;
      margin: 0 !important;
      padding: 4px !important;
    }

    .redacto-checkbox-small {
      appearance: none !important;
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
      height: 16px !important;
      width: 16px !important;
      border: 2px solid ${THEMED_CONTROL_OFF} !important;
      border-radius: 5px !important;
      background-color: transparent !important;
      cursor: pointer !important;
      position: relative !important;
      box-sizing: border-box !important;
      flex-shrink: 0 !important;
      margin: 0 !important;
      padding: 4px !important;
    }

    .redacto-checkbox-large:checked {
      background-color: ${THEMED_ACCENT} !important;
      border-color: ${THEMED_ACCENT} !important;
    }

    .redacto-checkbox-medium:checked {
      background-color: ${THEMED_ACCENT} !important;
      border-color: ${THEMED_ACCENT} !important;
    }

    .redacto-checkbox-small:checked {
      background-color: ${THEMED_ACCENT} !important;
      border-color: ${THEMED_ACCENT} !important;
    }

    .redacto-checkbox-large:checked::after,
    .redacto-checkbox-medium:checked::after {
      content: '' !important;
      position: absolute !important;
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%) rotate(45deg) !important;
      width: 4px !important;
      height: 8px !important;
      border: solid white !important;
      border-width: 0 2px 2px 0 !important;
      box-sizing: border-box !important;
    }

    .redacto-checkbox-small:checked::after {
      content: '' !important;
      position: absolute !important;
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%) rotate(45deg) !important;
      width: 3px !important;
      height: 6px !important;
      border: solid white !important;
      border-width: 0 1.5px 1.5px 0 !important;
      box-sizing: border-box !important;
    }

    .redacto-checkbox-large:indeterminate,
    .redacto-checkbox-medium:indeterminate {
      background-color: ${THEMED_ACCENT} !important;
      border-color: ${THEMED_ACCENT} !important;
    }

    .redacto-checkbox-large:indeterminate::after,
    .redacto-checkbox-medium:indeterminate::after {
      content: '' !important;
      position: absolute !important;
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%) !important;
      width: 8px !important;
      height: 2px !important;
      background-color: white !important;
    }

    .redacto-checkbox-large:focus,
    .redacto-checkbox-medium:focus {
      outline: 2px solid ${THEMED_ACCENT} !important;
      outline-offset: 2px !important;
    }

    .redacto-checkbox-small:focus {
      outline: 2px solid ${THEMED_ACCENT} !important;
      outline-offset: 2px !important;
    }

    /* TTS Highlight Styles */
    .redacto-tts-highlight {
      position: relative !important;
      transition: background-color 0.3s ease, outline 0.3s ease !important;
    }

    h2.redacto-tts-highlight,
    h3.redacto-tts-highlight {
      background-color: ${THEMED_TTS_BACKGROUND} !important;
      border-radius: 3px !important;
      padding: 2px 4px !important;
      margin: -2px -4px !important;
    }

    span.redacto-tts-highlight,
    a.redacto-tts-highlight {
      background-color: ${THEMED_TTS_BACKGROUND} !important;
      border-radius: 3px !important;
      padding: 2px 4px !important;
      margin: -2px -4px !important;
    }

    p.redacto-tts-highlight {
      background-color: ${THEMED_TTS_BACKGROUND} !important;
      border-radius: 3px !important;
      padding: 2px 4px !important;
      margin: -2px -4px !important;
    }

    /* Only when the admin chose one: classic keeps each element's own colour. */
    [${TTS_TEXT_ATTRIBUTE}] .redacto-tts-highlight {
      color: var(${NOTICE_THEME_VARS.ttsText}) !important;
    }

    button.redacto-tts-highlight {
      outline: 3px solid ${THEMED_TTS_BACKGROUND} !important;
      outline-offset: 2px !important;
    }

    /* Overlay fade-in */
    @keyframes overlayFadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    /* Spinner animation */
    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }

    /* DigiLocker callback retry button hover */
    .redacto-dl-retry-btn:hover {
      background-color: #2563eb !important;
    }
  `;

/**
 * Inject the checkbox / TTS / animation stylesheet into the given root.
 *
 * - When called with a `Document`, the style tag is placed in `document.head`.
 * - When called with a `ShadowRoot`, the style tag is placed inside the shadow
 *   so it only applies within that shadow tree (full CSS isolation from the
 *   host page).
 *
 * No-ops if the stylesheet is already present in the target root.
 */
export const injectCheckboxStyles = (
  root: Document | ShadowRoot
): void => {
  if (typeof document === "undefined") return;

  // Skip if already injected into this root.
  const existing =
    root instanceof Document
      ? root.getElementById(STYLE_ID)
      : root.querySelector(`#${STYLE_ID}`);
  if (existing) return;

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = STYLE_CONTENT;

  if (root instanceof Document) {
    root.head.appendChild(style);
  } else {
    root.appendChild(style);
  }
};
